export const information = {
  site: "thai_jun88k36",
  cskh_url: "https://ajun88.vip",
  cskh_home: "https://ajun88.vip",
  endpoint: "https://api-thai-jun88k36.freecodevip.org",
  // endpoint: "http://localhost:5039",
  key_free: "att.code-free.hau-dai.thai-Jun88-AE@2030$",
};
